var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{attrs:{"valid-characters-only":"","default-country":"BR","input-options":{
    placeholder: _vm.$t('informetelefone'),
    readonly: _vm.schema.readonly
  }},on:{"country-changed":_vm.countryChangedHandle},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }